export * from './error';
export * from './fetcher';
export * from './graphql';
export * from './schema';

import { setupGlobal } from '@affine/env/global';
import { getBaseUrl as _getBaseUrl } from '@docnboard/rest';

import { gqlFetcherFactory } from './fetcher';

setupGlobal();

export const getBaseUrl = _getBaseUrl;

export const fetcher = gqlFetcherFactory(getBaseUrl() + '/graphql');
